import { createAsyncThunk } from '@reduxjs/toolkit';
import { getBusinessContacts } from '../services/getBusinessContacts.service';
import {
  selectUserActiveEmployerInfo,
  selectUserActiveEmployerBusinessId,
} from 'store/user/selectors.js/user.selectors';

export const getBusinessContactsThunk = createAsyncThunk(
  'contacts/getBusinessContacts',
  async (_, { getState }) => {
    const state = getState();
    const businessId = selectUserActiveEmployerBusinessId(state);
    const activeEmployerInfo = selectUserActiveEmployerInfo(state);

    return await getBusinessContacts(businessId, activeEmployerInfo);
  }
);
